import React, { useState } from "react";
import Avatar from "@mui/material/Avatar";
//import {authUser} from "./fake-db";
import {
  ListItemIcon,
  ListItemText,
  ThemeProvider,
  Typography,
} from "@mui/material";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import RepeatOutlinedIcon from "@mui/icons-material/RepeatOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
//import {useNavigate} from "react-router-dom";
import JumboDdPopover from "@jumbo/components/JumboDdPopover";
import Div from "@jumbo/shared/Div";
import { useJumboTheme } from "@jumbo/hooks";
import { useOnLogout } from "../../../modules/app-auth/hook/index";
import { useSelector } from "react-redux";
import { history } from "../../../redux/store";
import { SCSGenericButton } from "app/modules/common/components/Buttons/SCSButtons";

const AuthUserDropdown = () => {
  const userRedux = useSelector((state) => state.userReducer);
  const [sendLogout, setSendLogout] = useState(false);

  var data = JSON.parse(sessionStorage.getItem("user"));
  const userCode = data ? data.key : "";

  useOnLogout(userCode, sendLogout, setSendLogout);

  const { theme } = useJumboTheme();

  const onLogout = () => {
    localStorage.clear();
    const url = "/?origen=corpfav&init=signincli";

    setSendLogout(true);
    window.opener = null;
    window.open(url, "_self");
    window.close();
  };

  const onPerfil = () => {
    //navigate("/perfil", {replace: true});
    history.push("/signin");
    //mutation.mutate();
  };

  return (
    <>
      <section style={{ width: "7rem" }}>
        <SCSGenericButton onClick={onLogout} titulo="SALIR" size={100} />
      </section>

      <ThemeProvider theme={theme}>
        {/* <JumboDdPopover
        triggerButton={
          <Avatar sizes={"small"} sx={{ boxShadow: 25, cursor: "pointer" }} />
        }
      >
        <Div
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            p: (theme) => theme.spacing(2.5),
          }}
        ></Div>
        <Divider />
        <nav>
          <List disablePadding sx={{ pb: 1 }}>
            <ListItemButton onClick={onLogout}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                <LogoutIcon />
              </ListItemIcon>
              <ListItemText primary="Salir" sx={{ my: 0 }} />
            </ListItemButton>
          </List>
        </nav>
      </JumboDdPopover> */}
      </ThemeProvider>
    </>
  );
};

export default AuthUserDropdown;
